function normalizePathname(pathname: string): string {
    if (pathname === '/') {
        return pathname;
    }

    return pathname.replace(/\/+$/, '') || '/';
}

function joinPathname(basePathname: string, path: string): string {
    const normalizedPath = path.replace(/^\/+/, '');

    if (!normalizedPath) {
        return normalizePathname(basePathname);
    }

    const normalizedBasePathname = normalizePathname(basePathname);
    const basePrefix = normalizedBasePathname === '/' ? '' : normalizedBasePathname;

    return `${basePrefix}/${normalizedPath}`;
}

export const getUrl = (baseUrl: string, path: string, search?: string): string => {
    const result = new URL(baseUrl);

    if (path) {
        result.pathname = joinPathname(result.pathname, path);
    }

    result.search = search || '';

    return result.toString();
};
